import get from 'lodash/get';
import keyBy from 'lodash/keyBy';

import featureAvailabilityService from '~lib/common/providers/featureAvailabilityService';

function validateMonitors(caseConf) {
  const errors = [];
  const warnings = [];

  const leadSelectTmt = (caseConf._treatments || []).find(tmt => tmt.id === 'LEAD_SELECT');
  const leadSelectEnabled = leadSelectTmt && leadSelectTmt.options.enabled;
  const leadsAvailable = get(leadSelectTmt, 'options.componentOptions.LEAD.availableValues');

  const labAssets = caseConf._labAssets || [];
  const labAssetsById = keyBy(labAssets, 'key');

  const padsEnabled = leadSelectEnabled && leadsAvailable &&
    leadsAvailable.find(val => val === 'PADS');
  const twelveLeadsEnabled = leadSelectEnabled && leadsAvailable &&
    leadsAvailable.find(val => val === 'TWELVE_LEADS');

  const pacingTmt = (caseConf._treatments || []).find(tmt => tmt.id === 'PACING');
  const pacingEnabled = pacingTmt && pacingTmt.options.enabled;

  const defibTmt = (caseConf._treatments || []).find(tmt => tmt.id === 'DEFIBRILLATION');
  const defibEnabled = defibTmt ? defibTmt.options.enabled : false;

  const syncTmt = (caseConf._treatments || []).find(tmt => tmt.id === 'SYNC');
  const syncEnabled = syncTmt ? syncTmt.options.enabled : false;

  const hasTwelveLeadAsset = get(labAssetsById, 'LEADS.options.assets.length') > 0;

  if (leadSelectEnabled) {
    if (!leadsAvailable || leadsAvailable.length === 0) {
      errors.push(monitorError('If Lead Select is on, at least one Lead must be enabled', 'LEAD_SELECT', 'LEAD'));
    }
  }

  if (pacingEnabled && !padsEnabled) {
    errors.push(monitorError('If Pacing is enabled, Lead Select and Pads must be enabled', 'PACING'));
  }

  if (defibEnabled && !padsEnabled) {
    errors.push(monitorError('If Defibrillation is enabled, Lead Select and Pads must be enabled', 'DEFIBRILLATION'));
  }

  if (syncEnabled && !padsEnabled) {
    errors.push(monitorError('If Sync is enabled, Lead Select and Pads must be enabled', 'SYNC'));
  }

  if (twelveLeadsEnabled && !hasTwelveLeadAsset) {
    const msg = `Twelve leads was enabled but a 12 lead image was not uploaded in ${featureAvailabilityService.translateLabel('Media')}`;
    warnings.push(monitorError(msg));
  }

  return {
    errors,
    warnings,
  };
}

function monitorError(message, id, componentId) {
  return {
    message,
    category: 'monitors',
    field: '_treatments',
    id,
    metadata: {
      componentId,
      scope: 'control',
    },
  };
}

export default validateMonitors;
